(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["farana-duo-builder"] && !Shopify.designMode) return;
  try {
    
function initFaranaBuilders(){document.querySelectorAll('[data-farana-builder]').forEach(function(root){if(root.dataset.ready)return;root.dataset.ready='1';
var data=JSON.parse(root.querySelector('[data-products]').textContent),form=root.querySelector('form'),tabs=[].slice.call(root.querySelectorAll('[data-family-btn]')),people=[].slice.call(root.querySelectorAll('[data-person]')),submit=root.querySelector('[data-submit]'),status=root.querySelector('[data-status]'),note=root.querySelector('[data-match]'),terms=root.querySelector('[data-terms]'),family='bags',busy=false,auto=false;
var TERMS={bags:"Remise de 10 € appliquée automatiquement au panier pour un sac banane adulte + un sac banane enfant. Non cumulable avec les autres remises sur la commande.",vests:"Remise de 10 € appliquée automatiquement au panier pour un gilet adulte + un gilet enfant. Non cumulable avec les autres remises sur la commande."};
var COLORS=['rose poudré','vert sapin','jaune moutarde','lin pailleté','beige','camel','noir','violet','fushia','fuchsia','gris','damier','fleuri','zèbre','jean'];
function money(n){return new Intl.NumberFormat('fr-FR',{style:'currency',currency:root.dataset.currency||'EUR'}).format(n/100)}
function opt(v,t,d){var o=document.createElement('option');o.value=v;o.textContent=t;o.disabled=!!d;return o}
function groups(){return family==='bags'?['banane','sac-banane-enfant']:['gilets-adultes','vetements']}
function list(i){return data.filter(function(x){return x.group===groups()[i]})}
function model(p){var i=people.indexOf(p),v=p.querySelector('[data-product]').value;return list(i).find(function(x){return String(x.id)===v})}
function chosen(p){var m=model(p),v=p.querySelector('[data-variant]').value;return m?m.variants.find(function(x){return String(x.id)===v}):null}
function colorOf(t){t=(t||'').toLowerCase();return COLORS.find(function(c){return t.indexOf(c)>-1})}
function hasStock(x){return x.variants.some(function(v){return v.available})}
function discount(){return Number(family==='vests'?root.dataset.vestDiscount:root.dataset.discount)||0}
function update(){var sel=people.map(chosen),ok=sel.every(function(v){return v&&v.available}),sum=ok?sel[0].price+sel[1].price:0,d=ok?Math.min(discount(),sum):0;
submit.disabled=busy||!ok;root.querySelector('[data-total]').textContent=ok?money(sum-d):'—';
var o=root.querySelector('[data-original]');o.hidden=!(ok&&d);o.textContent=ok?money(sum):'';
var s=root.querySelector('[data-saving]');s.hidden=!(ok&&d);s.textContent=ok&&d?'Vous économisez '+money(d):'';
people.forEach(function(p,i){p.querySelector('[data-price]').textContent=sel[i]?money(sel[i].price):'';p.classList.toggle('is-ready',!!(sel[i]&&sel[i].available))})}
function fill(p){var m=model(p),vs=p.querySelector('[data-variant]'),img=p.querySelector('[data-image]'),ph=p.querySelector('[data-placeholder]'),link=p.querySelector('[data-detail]'),isAdult=people.indexOf(p)===0;
vs.replaceChildren(opt('','Choisir…'));
if(m){var vars=m.variants.filter(function(v){return !isAdult||v.title.toLowerCase().indexOf('enfant')===-1});
vars.forEach(function(v){vs.append(opt(v.id,(v.title==='Default Title'?'Modèle unique':v.title)+(v.available?'':' — indisponible'),!v.available))});
var av=vars.filter(function(v){return v.available});if(av.length===1)vs.value=String(av[0].id);
if(m.image){img.src=m.image;img.alt=m.title;img.hidden=false;ph.hidden=true}else{img.hidden=true;ph.hidden=false}link.href=m.url;link.hidden=false}
else{img.hidden=true;ph.hidden=false;link.hidden=true}update()}
function autoMatch(){var a=model(people[0]);if(!a)return;var c=colorOf(a.raw||a.title),child=people[1],sel=child.querySelector('[data-product]');
if(!c||(sel.value&&!auto))return;var m=list(1).find(function(x){return (x.raw||x.title).toLowerCase().indexOf(c)>-1&&hasStock(x)});
if(m){sel.value=String(m.id);fill(child);auto=true;note.textContent='✓ Nous avons choisi le modèle enfant assorti ('+c+'). Vous pouvez le changer.';note.hidden=false}else if(auto){note.hidden=true}}
function reset(){people.forEach(function(p,i){var s=p.querySelector('[data-product]');s.replaceChildren(opt('','Choisir un modèle…'));
list(i).slice().sort(function(a,b){return hasStock(b)-hasStock(a)}).forEach(function(x){s.append(opt(x.id,x.title+(hasStock(x)?'':' — indisponible'),!hasStock(x)))});fill(p)});
auto=false;note.hidden=true;status.textContent='';root.querySelector('[data-cart]').hidden=true;terms.textContent=TERMS[family]}
tabs.forEach(function(b){b.addEventListener('click',function(){if(family===b.dataset.familyBtn)return;family=b.dataset.familyBtn;tabs.forEach(function(t){t.setAttribute('aria-checked',String(t===b))});reset()})});
people[0].querySelector('[data-product]').addEventListener('change',function(){fill(people[0]);autoMatch()});
people[1].querySelector('[data-product]').addEventListener('change',function(){auto=false;note.hidden=true;fill(people[1])});
people.forEach(function(p){p.querySelector('[data-variant]').addEventListener('change',update)});
form.addEventListener('submit',function(e){e.preventDefault();if(busy)return;var sel=people.map(chosen);if(!sel.every(function(v){return v&&v.available}))return;busy=true;update();status.textContent='Ajout en cours…';
fetch(root.dataset.root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:sel.map(function(v){return{id:v.id,quantity:1}})})})
.then(function(r){return r.json().then(function(j){if(!r.ok)throw new Error(typeof j.description==='string'?j.description:'');return j})})
.then(function(){status.textContent='C\'est fait : votre duo est dans le panier.';root.querySelector('[data-cart]').hidden=false;document.dispatchEvent(new CustomEvent('cart:refresh'))})
.catch(function(err){status.textContent=err.message||'L\'ajout a échoué. Vérifiez la disponibilité et réessayez.'})
.finally(function(){busy=false;update()})});
reset()})}
initFaranaBuilders();document.addEventListener('shopify:section:load',initFaranaBuilders);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-gallery"] && !Shopify.designMode) return;
  try {
    
(function(){
  const images = document.querySelectorAll('.mw-image-gallery a');
  const modal = document.querySelector('.mw-modal');
  const modalImage = modal.querySelector('img');
  let currentIndex = 0;
  
  // Open modal popup and show clicked image
  function showModal(index) {
    if(window.innerWidth > 749){
      modalImage.src = images[index].dataset.desktop;
    } else {
      modalImage.src = images[index].dataset.mobile;  
    }    
    modal.classList.add('show');
    currentIndex = index;
  }
  
  // Hide modal popup
  function hideModal() {
    modal.classList.remove('show');
  }
  
  // Show previous image in gallery
  function showPrevImage(e) {
    e.stopPropagation()
    if (currentIndex === 0) {
      showModal(images.length - 1);
    } else {
      showModal(currentIndex - 1);
    }
  }
  
  // Show next image in gallery
  function showNextImage(e) {
    e.stopPropagation()
    if (currentIndex === images.length - 1) {
      showModal(0);
    } else {
      showModal(currentIndex + 1);
    }
  }
  
  // Add click event listeners to all images
  images.forEach((image, index) => {
    image.addEventListener('click', (e) => {
      e.preventDefault()
      showModal(index);
    });
  });  
    
  // Add click event listeners to modal navigation arrows
  const prevArrow = modal.querySelector('.mw-modal-prev');
  prevArrow.addEventListener('click', showPrevImage);
  
  const nextArrow = modal.querySelector('.mw-modal-next');
  nextArrow.addEventListener('click', showNextImage);
  
  // Add click event listener to modal background to hide it
  modal.addEventListener('click', hideModal);

  
})()

  } catch(e) { console.error(e); }
})();
})();
